import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgRefreshIcon from './svgs/RefreshIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var refreshIcon = (props => useIcon(SvgRefreshIcon, SvgRefreshIcon, props));

export { refreshIcon as default };
